import type { SearchKey } from '@finn-no/search-frontend-clients/quest';
import React from 'react';

export const initialStateTypeMap = {
    actionUrl: String(),
    apiUrl: String(),
    isLandingPage: Boolean(),
    isProbablyMobile: Boolean(),
    searchKey: String(),
    searchPlaceholder: String(),
    searchTerm: String(),
    siteUrl: String(),
    vertical: String(),
    where: String(),
};

export type InitialStateKey = keyof typeof initialStateTypeMap;

export type InitialState = Omit<
    {
        [Property in InitialStateKey]: typeof initialStateTypeMap[Property];
    },
    'apiUrl' | 'searchKey' | 'searchTerm'
> & {
    apiUrl: string | null;
    searchKey: SearchKey | null;
    searchTerm: string | null;
};

export type AppConfig = Omit<
    InitialState,
    'isProbablyMobile' | 'searchPlaceholder' | 'searchTerm'
>;

export const AppConfigContext = React.createContext<AppConfig>({} as AppConfig);

// TODO: memoize context object?
export const useAppConfig = () => React.useContext(AppConfigContext);
